export const PAYMENT_OPTIONS = [
  { id: 0, value: "", label: "Select Payment Method" },
  { id: 1, value: "Cash", label: "By Cash" },
  { id: 2, value: "Google Pay", label: "By Google Pay" },
  { id: 3, value: "Paytm", label: "By Paytm" },
  { id: 4, value: "PhonePe", label: "By PhonePe" },
  { id: 5, value: "Credit/Debit Card", label: "By Credit/Debit Card" },
  { id: 6, value: "Netbanking", label: "By Netbanking" },
  { id: 7, value: "Amazon Pay", label: "By Amazon Pay" },
  { id: 8, value: "Other", label: "Other" },
];

export const DEFAULT_PROCEDURE_DETAILS = {
  cgst_percent: 0,
  consultation_fee_in_rupees: 0,
  consultation_name: "",
  consultation_type: "",
  convenience_fee_in_rupees: 0,
  discount_on_consultation_fee_in_rupees: 0,
  discount_percent: 0,
  fee_in_rupees: 0,
  gst_in_rupees: 0,
  igst_percent: 0,
  inputValue: 0,
  procedure_id: "",
  procedure_name: "",
  sgst_percent: 0,
  subtotal_in_rupees: 0,
  total_fee_in_rupees: 0,
  refund_in_rupees: 0,
  final_amount_in_rupees: 0,
  is_deleted: false,
};

export const DEFAULT_CONSULTATION_TYPE = [
  { value: "6", label: "In-clinic Follow-up" },
  { value: "5", label: "In-clinic Regular" },
];

export const PAYMENT_DETAILS = {
  payment_method: "",
  amount: "",
  transaction_id: "",
  specify_other: false,
};
